<template>
   <section class="jsk-block">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-7 col-md-12">
            <p class="h3">{{ $t("courseDetails.curricula") }}</p>
            <ul class="pl-3 pt-3" v-html="curricula"></ul>
          </div>
          <div class="col-12 col-lg-5 col-md-12 text-right d-lg-block d-none">
            <img v-bind:src="imgUrl" class="img-fluid" alt="jskids modul incepatori">
          </div>
        </div>
      </div>
    </section>
</template>


<script>
export default {
  name: "courseCurricula",
  props: ["curricula", "imgUrl"]
};
</script>